import * as types from '../actions/types';

const initState = {
    locale: 'cs'
};

export default function LangReducer (state = initState, action) {
    switch (action.type) {

        case types.LANGUAGE_SET:
            return {...state, locale: action.payload.locale };

        case types.LANGUAGE_SET_SUCCESS:
            return {...state, locale: action.payload.locale };

        case types.LANGUAGE_SET_ERROR:
            return {...state, error: action.payload };

        default:
            return state;
    }
}
